import React from 'react';
import { Modal, Icon, Button } from "semantic-ui-react";

export function PopupNodeAuthorizationFormSent(props) {

    const { open, onAcceptReload} = props;
  return (
    <Modal
            basic
            //onClose={() => setShowModal(false)}
            //onOpen={() => setShowModal(true)}
            size='mini'
            open={open}
        >
            <Modal.Header icon="true">
            <Icon name='send' />
                Form sent successfully, an email is sent to your technical contact to validate your email.
            </Modal.Header>
            <Modal.Actions>
                <Button fluid type='reset' color='green' size='mini' onClick={onAcceptReload}>
                    <Icon name='checkmark' /> Accept
                </Button>
            </Modal.Actions>
        </Modal>
  )
}
